module.exports = __webpack_public_path__ + "img/article-3.31c0885e.jpg";